import React from 'react';
import PropTypes from 'prop-types';
import {trans} from './../../../../systems/i18n';
import {Button, Menu, Dropdown, Icon, Checkbox} from 'antd';
import {TYPES} from "../constants";

class ListTransactionSetting extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {isOpen: false, object: props.object, isCurrentPage: props.isCurrentPage};
    }

    onChangeOption(optionKey, event) {
        let values = event.target.checked
            ? [...this.props.values, optionKey]
            : this.props.values.filter(value => value !== optionKey);

        this.props.onChange(values);
    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {...state};
        if (nextState.object !== props.object) {
            nextState.object = props.object;
            nextState.isOpen = false
        } else {
            nextState.isOpen = nextState.object === props.isCurrentPage ? props.isOpenListSetting : false;
            nextState.isCurrentPage = props.isCurrentPage
        }
        return nextState;
    }
    render() {
        return (
            <Dropdown
                visible={this.state.isOpen}
                overlay={this.renderMenu()}
                trigger={['click']}
                overlayClassName={'a-dropdown--set-field'}
            >
                <Button
                    className=" a-font--12 aphz-50 a-btn--primary-ant ghost " size={"small"}
                    onClick={() => this.props.onOpenListSetting(true, this.state.object)}
                >
                    {trans('transaction:column_setting')}
                </Button>
            </Dropdown>
        );
    }

    renderMenu() {
        return (
            <Menu className="a-dropdown--set-field__menu">
                <div className="close-field-menu">
                    <Icon onClick={() => this.props.onOpenListSetting(false, this.state.object)} type="close"/>
                </div>
                {this.props.options.map(option => (
                    <Menu.Item
                        key={option.key}
                        className="a-dropdown--set-field__item"
                    >
                        <Checkbox
                            className="a-checkbox--set-field"
                            checked={this.props.values.includes(option.key)}
                            disabled={option.disabled}
                            onChange={this.onChangeOption.bind(this, option.key)}
                        >{trans('transaction:column.' + option.key)}</Checkbox>
                    </Menu.Item>
                ))}
            </Menu>
        )
    }
}

ListTransactionSetting.defaultProps = {
    options: [],
    values: [],
    isOpenListSetting: false,
    isCurrentPage: TYPES.SINGLE,
    onOpenListSetting: () => {
    },
    onChange: (values) => {},
};

ListTransactionSetting.propTypes = {
    options: PropTypes.array,
    values: PropTypes.array,
    onChange: PropTypes.func,
    onOpenListSetting: PropTypes.func,
    isCurrentPage: PropTypes.string,
    isOpenListSetting: PropTypes.bool
};

export default ListTransactionSetting;
